// extracted by css-extract-rspack-plugin
export default {"dragHandle":"xGy9k"};